// extracted by mini-css-extract-plugin
export default {"checkList__listItem":"styles-module--checkList__listItem--Ykp58","service":"styles-module--service--RplS3","discounts":"styles-module--discounts--jEGuT"};